module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-collapse', [_c('el-collapse-item', {
    staticClass: "sub-schema",
    attrs: {
      "title": _vm.title
    }
  }, [_c('schema-table', {
    ref: "table",
    attrs: {
      "schema": _vm.spec.schema,
      "initialFilter": _vm.filter,
      "embedded": true
    },
    on: {
      "dataChanged": _vm.dataChanged
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c5237866!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Forms/Fields/f-table.vue
// module id = 531
// module chunks = 55